import PrincipalsPage from './principal-page';

export default PrincipalsPage;